import './Order.scss'
import Order from './Order'
import { OrderProps } from './Order'
export default Order
export type { OrderProps }